<template>
    <el-col :xs="{span:24}" :md="width"  v-show="show">
        <el-form-item 
            :class="className"
            :label="displayName" 
            :prop="name"
            :rules="rules">
            <input :name="fieldName" :value="data[name]" hidden="hidden">
            <el-input 
                class="qweelement"
                v-model.lazy="data[name]"
                :disabled="disabled">
            </el-input>
            <div class="hint"><i>{{ hint }}</i></div>
        </el-form-item>
    </el-col>
</template>

<script>
    import qweBaseField from "../BaseField"

    export default {
        name:"PrimaryKeyField",
        mixins:[qweBaseField]
    }
</script>